module.exports = __webpack_public_path__ + "static/media/wizualizacja-54.418e24bf.png";